import { define } from './define';

// "Publicar hoy": the posts a person has to publish by hand, and the automatic ones that need a look. Keys start with "publish.".
export const publish = define({
  es: {
    'publish.title': 'Publicar hoy',
    'publish.toCalendar': 'Calendario',
    'publish.today': 'hoy',
    'publish.tomorrow': 'mañana',
    'publish.yesterday': 'ayer',

    'publish.due': 'Toca ahora',
    'publish.dueHint': 'Publicaciones a mano cuya hora ya ha llegado.',
    'publish.dueEmpty': 'Nada que publicar a mano ahora.',
    'publish.paused': 'La marca está en pausa, así que no hay nada pendiente de publicar.',
    'publish.text': 'Texto',
    'publish.noText': 'Sin texto',
    'publish.firstComment': 'Primer comentario',
    'publish.files': 'Archivos',
    'publish.noFiles': 'Esta versión no tiene archivos que descargar.',
    'publish.file.video': 'Vídeo',
    'publish.file.image': 'Imagen {n}',
    'publish.file.cover': 'Portada',
    'publish.file.subtitles': 'Subtítulos',
    'publish.file.pdf': 'PDF',
    'publish.downloadFile': 'Descargar {name}',
    'publish.link': 'Enlace a la publicación (opcional)',
    'publish.linkPlaceholder': 'https://',
    'publish.mark': 'Marcar como publicada',
    'publish.marked': 'Marcada como publicada',
    'publish.waits': 'Espera a que salga otra publicación de la que depende.',
    'publish.noPermission': 'Solo quien puede programar en esta marca puede marcarla como publicada.',

    'publish.attention': 'Necesita atención',
    'publish.attentionHint': 'Publicaciones automáticas que han fallado o que han salido sin ser públicas.',
    'publish.history': 'Historial',
    'publish.retry': 'Reintentar…',
    'publish.handOver': 'La publico a mano',
    'publish.handOverTitle': '¿La publicas tú a mano?',
    'publish.handOverConfirm': 'La app dejará de intentarlo y la publicación aparecerá en «Toca ahora» a su hora, con el texto y los archivos listos.',
    'publish.handedOver': 'Pasada a mano: aparecerá en «Toca ahora» a su hora',
    'publish.recheck': 'Comprobar otra vez',
    'publish.rechecking': 'Comprobando otra vez',

    'publish.upcoming': 'Próximas',
    'publish.upcomingHint': 'Lo programado para las dos próximas semanas.',
    'publish.upcomingEmpty': 'Nada programado en las dos próximas semanas.',
    'publish.slots': 'Huecos sin contenido',
    'publish.slotsHint': 'Huecos fijos de la semana que todavía no tienen publicación.',
    'publish.slotUnnamed': 'Hueco sin nombre',
    'publish.slotWeek': 'Ver la semana',
  },
  en: {
    'publish.title': 'Publish today',
    'publish.toCalendar': 'Calendar',
    'publish.today': 'today',
    'publish.tomorrow': 'tomorrow',
    'publish.yesterday': 'yesterday',

    'publish.due': 'Due now',
    'publish.dueHint': 'Posts published by hand whose hour has come.',
    'publish.dueEmpty': 'Nothing to publish by hand right now.',
    'publish.paused': 'This brand is paused, so nothing is listed as due.',
    'publish.text': 'Text',
    'publish.noText': 'No text',
    'publish.firstComment': 'First comment',
    'publish.files': 'Files',
    'publish.noFiles': 'This version has no files to download.',
    'publish.file.video': 'Video',
    'publish.file.image': 'Image {n}',
    'publish.file.cover': 'Cover',
    'publish.file.subtitles': 'Subtitles',
    'publish.file.pdf': 'PDF',
    'publish.downloadFile': 'Download {name}',
    'publish.link': 'Link to the post (optional)',
    'publish.linkPlaceholder': 'https://',
    'publish.mark': 'Mark as published',
    'publish.marked': 'Marked as published',
    'publish.waits': 'Waits for another post it depends on to go out.',
    'publish.noPermission': 'Only someone who can schedule for this brand can mark it as published.',

    'publish.attention': 'Needs attention',
    'publish.attentionHint': 'Automatic posts that failed, or that went out but are not public.',
    'publish.history': 'History',
    'publish.retry': 'Try again…',
    'publish.handOver': "I'll do it by hand",
    'publish.handOverTitle': 'Publish this one by hand?',
    'publish.handOverConfirm': 'The app stops trying, and the post shows up in “Due now” at its hour with its text and files ready.',
    'publish.handedOver': 'Handed over: it shows up in “Due now” at its hour',
    'publish.recheck': 'Check again',
    'publish.rechecking': 'Checking again',

    'publish.upcoming': 'Coming up',
    'publish.upcomingHint': 'What is scheduled for the next two weeks.',
    'publish.upcomingEmpty': 'Nothing scheduled for the next two weeks.',
    'publish.slots': 'Slots that need content',
    'publish.slotsHint': 'Weekly slots that do not have a post yet.',
    'publish.slotUnnamed': 'Unnamed slot',
    'publish.slotWeek': 'See the week',
  },
});
